import React from 'react';
import './Hero.scss';
import { CiCloudOn    } from "react-icons/ci";
import { FiCheckCircle } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import { TfiBarChart, TfiWorld  } from "react-icons/tfi";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { AiOutlineThunderbolt } from "react-icons/ai";


export default function Hero() {
  // Datos de las tarjetas de abajo para no repetir código HTML (buenas prácticas, plebe)
  const tarjetas = [
    { id: 1, icono:<CiCloudOn />, titulo: "100% EN LÍNEA", desc: "Gestiona tu información desde cualquier lugar." },
    { id: 2, icono:<GoPerson />, titulo: "ATENCIÓN PERSONALIZADA", desc: "Recibe acompañamiento cuando lo necesites." },
    { id: 3, icono: <TfiBarChart />, titulo: "EQUIPO PROFESIONAL", desc: "Especialistas en contabilidad, impuestos y cumplimiento fiscal." },
    { id: 4, icono: <FiCheckCircle />, titulo: "MAYOR ORDEN Y CLARIDAD", desc: "Toma mejores decisiones con información precisa y oportuna." }
  ];

  return (
    <section className="hero-container"> 
      {/* CONTENEDOR DEL VIDEO DE FONDO */}
      <div className="hero-video-wrapper">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline 
          className="hero-video" 
          src="/video/video-fondo.mp4" 
        />
      </div>

      {/* CAPA OSCURA PARA QUE SE LEA EL TEXTO */}
      <div className="hero-overlay"></div>

      {/* CONTENIDO PRINCIPAL */}
      <div className="hero-content">
        <span className="hero-subtitle">CONTABILIDAD PROFESIONAL PARA EMPRESAS</span>
        <h1 className="hero-title">
          Contabilidad Profesional <br />
          para Empresas y PYMES <br />
          en México
        </h1>
        <p className="hero-description">
          Servicios contables 100% en línea con atención personalizada, respuesta rápida y un equipo experto que te ayuda a mantener tu negocio en orden.
        </p>

        {/* BOTONES PRINCIPALES */}
        <div className="hero-buttons">
          <button className="btn-primary">
            <span className="icon"><MdOutlineCalendarMonth /> </span> Agenda tu Asesoría
          </button>
          <button className="btn-secondary">
            <span className="icon"><FaWhatsapp /></span> Enviar WhatsApp
          </button>
        </div>

        {/* MINI CARACTERÍSTICAS */}
        <div className="hero-mini-features">
          <div className="mini-item"><TfiWorld /> Atención en todo México</div>
          <div className="mini-item"><IoShieldCheckmarkOutline /> Servicios 100% digitales</div>
          <div className="mini-item"><AiOutlineThunderbolt /> Atención rápida y profesional</div>
        </div>
      </div>

      {/* TARJETAS FLOTANTES (Las que se enciman en la siguiente sección) */}
      <div className="hero-floating-cards">
        <div className="cards-grid">
          {tarjetas.map((card) => (
            <div key={card.id} className="card-item">
              <div className="card-icon">{card.icono}</div>
              <h3>{card.titulo}</h3>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}